//STATES

export const setData = (data) => {
    return {
        type: 'SET_STATES_DATA',
        data
    }
}


export const setError = (data) => {
    return {
        type: 'SET_STATES_ERROR',
        data
    }
}

export const setLoading = (data) => {
    return {
        type: 'SET_STATES_LOADING',
        data
    }
}
